module.exports = __webpack_public_path__ + "./images/abc387dd95beb4bec7b26a15af6f4bed.jpg";